﻿(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const first = root.querySelector('[data-step="1"]');
    const second = root.querySelector('[data-step="2"]');
    if (!form || !first || !second) {
      const bar = root.querySelector('.balk');
      if (bar && root.querySelector('[role="status"]')) bar.hidden = true;
      return;
    }
    const field = name => form.elements.namedItem(`contact[${name}]`);
    const address = ['straat', 'postcode', 'plaats'].map(field);
    const sample = form.querySelector('[data-sample]');
    second.hidden = true;
    function show(step) {
      first.hidden = step !== 1;
      second.hidden = step !== 2;
      address.forEach(input => { input.required = step === 2; });
      const target = step === 1 ? first : second;
      target.querySelector('input').focus();
      target.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
    function validate(container) {
      let invalid = null;
      container.querySelectorAll('input').forEach(input => {
        if (input.required && !input.value.trim()) input.value = '';
        const valid = input.checkValidity();
        input.setAttribute('aria-invalid', String(!valid));
        const error = input.closest('.veld').querySelector('.fout');
        if (error) {
          error.classList.toggle('aan', !valid);
          input.setAttribute('aria-describedby', error.id);
        }
        if (!valid && !invalid) invalid = input;
      });
      if (invalid) { invalid.focus(); invalid.reportValidity(); }
      return !invalid;
    }
    first.querySelector('[data-next]').addEventListener('click', () => {
      if (validate(first)) show(2);
    });
    first.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input')) {
        event.preventDefault();
        if (validate(first)) show(2);
      }
    });
    second.querySelector('[data-back]').addEventListener('click', () => show(1));
    second.querySelector('[data-skip]').addEventListener('click', () => {
      sample.value = 'Nee';
      address.forEach(input => { input.required = false; input.disabled = true; });
      field('land').disabled = true;
      form.requestSubmit();
    });
    form.addEventListener('submit', event => {
      if (!validate(first)) { event.preventDefault(); show(1); return; }
      if (sample.value !== 'Nee' && (second.hidden || !validate(second))) {
        event.preventDefault();
        show(2);
        return;
      }
      form.querySelectorAll('button').forEach(button => { button.disabled = true; });
    });
    form.addEventListener('input', event => {
      if (!event.target.matches('input')) return;
      event.target.removeAttribute('aria-invalid');
      const error = event.target.closest('.veld')?.querySelector('.fout');
      if (error) error.classList.remove('aan');
    });
  }
  document.querySelectorAll('[data-cattery-club]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-cattery-club]').forEach(init);
  });
})();
